<ng-container *ngIf="message && (!message.flags || !message.flags.includes(mssEnumFlag.DRAFT))">
  <div class="message-subject">
    <div class="message-subject-wording">
      {{ message.subject }}
      <div class="message-have-attachments" *ngIf="message.attachments && message.attachments.length > 0"></div>
    </div>

    <div class="actions-buttons">
      <div mat-icon-button [matMenuTriggerFor]="menuMessageActions" class="icon more-actions"></div>
      <div class="icon extend" (click)="extendMessageZone(!isExtend)"></div>
      <div class="icon-more-container">
        <mat-menu #menuMessageActions="matMenu">
          <button mat-menu-item (click)="messageAction('reply')">
            <span>Répondre</span>
          </button>
          <button mat-menu-item (click)="messageAction('replyToAll')">
            <span>Répondre à tous</span>
          </button>
          <button mat-menu-item (click)="messageAction('forward')">
            <span>Transférer</span>
          </button>
          <button mat-menu-item (click)="askBeforeDelete()">
            <span>Supprimer</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="message-header">
    <div class="message-sender">
      <span class="message-sender-name" *ngIf="senderName && senderName.name">{{ senderName.name }}</span>
      <span class="message-sender-email" *ngIf="senderName"><{{ senderName.email }}></span>
    </div>

    <div class="message-date">{{ getMessageDate(message) | date: 'dd/MM/yyyy' }}</div>
  </div>

  <div class="message-body" *ngIf="message.body && messageBodySanitized">
    <ng-container *ngIf="message.addresses && messageToAddress && messageToAddress.length > 0">
      Destinataires :
      <div class="message-to-address" *ngFor="let address of messageToAddress">
        <span>{{ address.name ? address.name : '' }} <{{ address.email }}></span>
      </div>
    </ng-container>
    <ng-container *ngIf="message.addresses && messageCcAddress && messageCcAddress.length > 0">
      CC :
      <div class="message-cc-address" *ngFor="let address of messageCcAddress">
        <span>{{ address.name ? address.name : '' }} <{{ address.email }}></span>
      </div>
    </ng-container>
    <ng-container *ngIf="message.addresses && messageBccAddress && messageBccAddress.length > 0">
      CCI :
      <div class="message-bcc-address" *ngFor="let address of messageBccAddress">
        <span>{{ address.name ? address.name : '' }} <{{ address.email }}></span>
      </div>
    </ng-container>
    <div [innerHTML]="messageBodySanitized"></div>
  </div>

  <div class="message-attachments" *ngIf="message.attachments && message.attachments.length > 0">
    <div class="message-attachments-wrapper">
      <div *ngTemplateOutlet="attachmentItems;context:{attachments: message.attachments}"></div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="message && message.flags && message.flags.includes(mssEnumFlag.DRAFT) && formGroup">
  <div class="header-wrapper">
    <div mat-icon-button [matMenuTriggerFor]="menuMessageActionsDraft" class="icon more-actions"></div>
    <div class="extend" (click)="extendMessageZone(!isExtend)"></div>
    <div class="icon-more-container">
      <mat-menu #menuMessageActionsDraft="matMenu">
        <button mat-menu-item (click)="askBeforeDelete()">
          <span>Supprimer</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="message-sender-wrapper">
    <frg-form-input
      label="Expéditeur"
      id="messageSender"
      [formGroup]="formGroup"
      [control]="formGroup.get('messageSender')"
      type="text"
    ></frg-form-input>
  </div>

  <div class="message-recipients-wrapper">
    <div class="recipients-input">
      <frg-form-input
        label="Destinataires"
        id="messageRecipients"
        [formGroup]="formGroup"
        [control]="formGroup.get('messageRecipients')"
        type="text"
      ></frg-form-input>
      <frg-button (activated)="findRecipients('messageRecipients')">
        <div class="search-icon"></div>
      </frg-button>
    </div>

    <div class="recipients-input">
      <frg-form-input
        label="CC"
        id="messageCcRecipients"
        [formGroup]="formGroup"
        [control]="formGroup.get('messageCcRecipients')"
        type="text"
      ></frg-form-input>
      <frg-button (activated)="findRecipients('messageCcRecipients')">
        <div class="search-icon"></div>
      </frg-button>
    </div>

    <div class="recipients-input">
      <frg-form-input
        label="CCI"
        id="messageBccRecipients"
        [formGroup]="formGroup"
        [control]="formGroup.get('messageBccRecipients')"
        type="text"
      ></frg-form-input>
      <frg-button (activated)="findRecipients('messageBccRecipients')">
        <div class="search-icon"></div>
      </frg-button>
    </div>
    <div class="recipients-input">
      <frg-form-input
        label="Patient"
        id="patientSubject"
        [formGroup]="formGroup"
        [control]="formGroup.get('messagePatient')"
        type="text"
        disabled="true"
        [title]="currentMessagePatient?.mssAddress ? currentMessagePatient.mssAddress : ''"
      ></frg-form-input>
      <frg-button (activated)="findPatient()">
        <div class="search-icon"></div>
      </frg-button>
    </div>
  </div>

  <frg-form-input
    id="accuseReception"
    label="Accusé Reception"
    type="checkbox"
    isCheckLabelAlign="true"
    [formGroup]="formGroup"
    [control]="formGroup.get('messageAccuseReception')"
  ></frg-form-input>

  <div class="message-subject-wrapper">
    <frg-form-input
      label="Objet"
      id="messageSubject"
      [formGroup]="formGroup"
      [control]="formGroup.get('messageSubject')"
      type="text"
    ></frg-form-input>
  </div>

  <div class="quill-wrapper" [formGroup]="formGroup">
    <!-- Vu avec Joël, ici laisser Quill car cette partie n'est pas utilisée, aucun problème si l'éditeur ne fonctionne pas...Ne pas toucher. -->
    <quill-editor appQuillRemoveButtons [buttonsToRemove]="['ql-image', 'ql-video']" title="" theme="snow" classes="test" formControlName="messageBody"
        placeholder="Rédigez votre email ici...">
    </quill-editor>
  </div>

  <div class="message-attachments">
    <div class="buttons-wrapper">
      <frg-button (click)="selectDocuments()">Ajouter une pièce jointe</frg-button>
    </div>
    <div class="message-attachments-wrapper" *ngIf="message.attachments && message.attachments.length > 0">
      <div *ngTemplateOutlet="attachmentItems;context:{attachments: message.attachments, isEdit: true}"></div>
    </div>
  </div>

  <div class="buttons-wrapper">
    <frg-button [backgroundColor]="'var(--danger)'" (activated)="cancelDraft()">Annuler</frg-button>
    <frg-button (activated)="saveDraft()" *ngIf="canDraftMessage">Enregistrer</frg-button>
    <frg-button [disabled]="!formGroup.valid" (activated)="sendMessage()">Envoyer</frg-button>
  </div>
</ng-container>

<ng-template #attachmentItems let-attachments="attachments" let-isedit="isEdit">
  <div
    class="attachment"
    [ngClass]="{ 'selected': selectedAttachmentPart && attachment.part && attachment.part === selectedAttachmentPart,
    'clinical-document': attachment.clinicalDocument }"
    *ngFor="let attachment of attachments"
    [title]="attachment.fileName"
    mat-icon-button
    [matMenuTriggerFor]="menu"
    (menuOpened)="selectAttachment(attachment.part)"
    (menuClosed)="selectAttachment(attachment.part)"
  >
    <div class="icon"></div>
    <div class="attachment-title">{{ attachment.fileName }}</div>
    <div class="icon-more-container">
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="downloadAttachment(attachment)">
          <span>Télécharger</span>
        </button>
        <button mat-menu-item (click)="addAttachmentToPatient(attachment)" *ngIf="!isedit">
          <span>Ajouter au dossier patient</span>
        </button>
        <button mat-menu-item (click)="deleteDraftAttachment(attachment)" *ngIf="isedit">
          <span>Supprimer</span>
        </button>
      </mat-menu>
    </div>
  </div>
</ng-template>
